import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeIn } from "../FadeIn";
import { useT } from "../../lib/i18n";
import { ROMAIN_PORTRAIT } from "../../lib/images";

export const AboutSection = () => {
  const t = useT();

  return (
    <section
      data-testid="about-section"
      className="py-16 md:section-pad container-x bg-ink relative"
    >
      <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <FadeIn className="md:col-span-5">
          <div className="aspect-[4/5] overflow-hidden rounded-sm max-w-sm md:max-w-none mx-auto">
            <img
              src={ROMAIN_PORTRAIT}
              alt="Romain Bruneau · photographe en action"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </FadeIn>
        <FadeIn delay={0.2} className="md:col-span-7">
          <div className="eyebrow mb-4 md:mb-6">{t("about.eyebrow")}</div>
          <h2 className="font-display text-4xl sm:text-5xl md:text-7xl leading-[0.95] mb-8 md:mb-10">
            {t("about.heading")}
          </h2>
          <p className="text-bone/70 leading-relaxed max-w-lg mb-6">
            {t("about.p1")}
          </p>
          <p className="text-bone/70 leading-relaxed max-w-lg mb-8">
            {t("about.p2")}
          </p>
          <Link
            to="/portfolio"
            data-testid="who-cta"
            data-cursor="VOIR"
            className="inline-flex items-center gap-3 text-stone hover:gap-5 transition-all"
          >
            <span className="text-[11px] tracking-[0.22em] uppercase">
              {t("about.cta")}
            </span>
            <ArrowRight size={16} />
          </Link>
        </FadeIn>
      </div>
    </section>
  );
};
